<template>
  <el-drawer 
    :title="dialogTitle" 
    :visible.sync="dialogVisible" 
    direction="rtl" 
    :size="currentStep == 1 ? '50%' : '75%'" 
    :before-close="handleClose">
    
    <!-- 动态标题栏 -->
    <div v-if="currentStep == 2" slot="title" class="dialog-footer">
      <div style="font-size: 14px;">
        <span style="font-size: 18px;">{{ platformName }}批量铺货设置</span>
        <span style="color: #e9a249;"> 
          <i class="el-icon-warning" style="margin-left: 4px;font-size: 14px;"></i> 
          商品发布成功后请务必及时去平台检查商品信息，以平台信息为准
        </span>
      </div>
    </div>
    
    <!-- 动态内容区域 -->
    <div :style="`padding: 0px 20px;overflow-y: ${currentStep === 1 ? 'scroll' : 'hidden'};height: 100%;`">
      <!-- 动态加载第一步组件 -->
      <component 
        v-if="currentStep === 1 && stepOneComponent"
        :is="stepOneComponent"
        ref="StepOneRef"
        :platform="platform"
        :getIds="getIds" 
        :selectShops="selectShops"
        :selectedShopList="selectedShopList"
        :configData="configData"
        :showShopList="showShopList"
        :goodsFissionRulesList="goodsFissionRulesList"
        v-bind="stepOneProps"
      />
      
      <!-- 动态加载第二步组件 -->
      <component 
        v-show="currentStep === 2 && stepTwoComponent"
        :is="stepTwoComponent"
        ref="StepTwoRef"
        :platform="platform"
        :getIds="getIds"
        :selectedShopList="selectedShopList"
        :configData="configData"
        :preSaleTime="preSaleTime" 
        :flowNumber="flowNumber" 
        :selectRowsDataLength="selectRowsData.length"
        :goodsFissionRulesList="goodsFissionRulesList"
        :selectShops="selectShops"
        :stepOneData="stepOneData"
        @on-cancel="handleClose"
        @getQueryProgress="getDetailProgress"
        @changeFxgSizeAi="changeFxgSizeAi"
        v-bind="stepTwoProps"
      />
    </div>
    
    <!-- 底部操作按钮 -->
    <div class="dialog-footer demo-drawer__footer">
      <el-button 
        v-if="currentStep == 1" 
        type="primary" 
        @click.native="handleNext"
        :loading="nextLoading">
        下一步，确认商品信息
      </el-button>
      
      <el-button 
        v-if="currentStep == 2" 
        type="primary" 
        @click.native="() => handleDistribution()"
        :loading="distributionLoading">
        去铺货
      </el-button>
      <el-button 
        v-if="currentStep == 2" 
        type="primary" 
        @click="preViewFission"
      >
        先预览，再铺货
      </el-button>
      <el-tooltip v-if="currentStep == 1" effect="dark" content="根据所选商品信息进行铺货，不符合铺货条件的商品将跳过，注意查看商品铺货日志" placement="top">
          <el-button @click="handleSkipPublish">跳过商品信息确认，直接铺货</el-button>
      </el-tooltip>
      <el-button @click="handleClose">取 消</el-button>
    </div>

    <!-- 异常确认弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="confirmDialogVisible"
      width="520px">
      <div v-html="confirmDialogMessage"></div>
      <span slot="footer">
        <el-button type="primary" @click="confirmDialogVisible = false">前去调整</el-button>
        <el-button @click="confirmDialogSecondaryAction" :loading="distributionLoading"> 继续铺货</el-button>
      </span>
    </el-dialog>
    <div class="loadingBox" v-if="nextLoading">
      <div class="loadingCon">
        <div style="font-size:18px;color:#999;"><i class="el-icon-loading"></i></div>
        <div><span style="color:#ccc;">商品信息正在加载中...已加载</span><span>{{detailDataProgress.curNum}}/{{detailDataProgress.total}}</span></div>
        <div><el-button type="link" @click="handleSkipLoadPublish">跳过加载，直接铺货</el-button></div>
        <div><el-button type="link" @click="handlePrev">返回上一步</el-button></div>
        <div><el-button type="link" @click="handleNextLoad">关闭</el-button></div>
      </div>
    </div>
    <CheckKd ref="checkKdRef" />
  </el-drawer>
</template>

<script>
import { merge } from 'lodash';
import { PLATFORM_BATCH_CONFIG } from './config/platformConfig.js'
import platformMixin from './mixins/platformMixin.js'
import { getDistributionConfig } from '@servers/prod/conf/index.js';
import { PLATFORMID_MAP } from '@/dictionary/platforms.js'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import CheckKd from '@components/prod/center/BasicComps/CheckKd.vue'
import { publishLimit } from '@/utils/index.js';

export default {
  name: 'BatchDistributionContainer',
  
  mixins: [platformMixin],
  
  props: {
    // 选中的店铺列表
    selectShops: {
      type: Array,
      default: () => []
    },
    // 获取ID的方法
    getIds: {
      type: Function,
      required: true
    },
    // 平台类型 - 从父组件传入
    platform: {
      type: String,
      required: true,
      default: 'fxg'
    },
    showShopList: {
      type: Array,
      default: () => []
    }
  },
  components:{
    CheckKd
  },
  
  data() {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 当前步骤
      currentStep: 1,
      preSaleTime: '',
      // 流程号
      flowNumber: '',
      // 选中的行数据
      selectRowsData: [],
      selectedShopList: [],  // 选中的店铺
      configData: {},  // 铺货配置数据
      // 动态组件
      stepOneComponent: null,
      stepTwoComponent: null,
      // 加载状态
      nextLoading: false,
      distributionLoading: false,
      detailDataProgress: {
        curNum:0,
        total:0
      },
      // 组件属性
      stepOneProps: {},
      stepTwoProps: {},
      stepOneData:{}, // 步骤一中的数据
      // 异常确认弹窗
      confirmDialogVisible: false,
      confirmDialogMessage: '',
      confirmDialogSecondaryAction: () => {},
    }
  },
  
  computed: {
    ...mapGetters(['prodRePublishRowData', 'routerPrefix', 'displayRePublishData','get_AllShops_BySource','isDistributor','goodsFissionRulesList']),
    
    // 动态弹窗标题
    dialogTitle() {
      const titleMap = {
        1: `${this.platformName}批量铺货设置`,
        2: `${this.platformName}批量铺货设置`
      }
      return titleMap[this.currentStep] || '批量铺货设置'
    },
  },
  
  watch: {
    // 监听平台变化，动态加载组件
    platform: {
      immediate: true,
      handler(newPlatform) {
        this.PLATFORMID = PLATFORMID_MAP[newPlatform] || newPlatform
      }
    },
  },
  
  methods: {
    ...mapActions(['publishSpeed', 'clearRePublishRowData', 'clearDisplayRePublishRowData','getGoodsFissionRules']),
    ...mapMutations(['setCurrentPage']),    
    /**
     * 动态加载平台组件
     * @param {string} platform - 平台标识
     */
    async loadPlatformComponents(platform) {
      try {
        const config = PLATFORM_BATCH_CONFIG[platform]
        if (!config) {
          console.error(`不支持的平台: ${platform}`)
          return
        }
        
        // 动态导入组件
        const [stepOneModule, stepTwoModule] = await Promise.all([
          config.stepOneComponent(),
          config.stepTwoComponent()
        ])
        
        this.stepOneComponent = stepOneModule.default
        this.stepTwoComponent = stepTwoModule.default
        
        // 设置平台特定的组件属性
        this.setupPlatformProps(platform)
        
      } catch (error) {
        console.error(`加载${platform}平台组件失败:`, error)
        this.$message.error(`加载${this.platformName}组件失败`)
      }
    },
    
    /**
     * 设置平台特定的组件属性
     * @param {string} platform - 平台标识
     */
    setupPlatformProps(platform) {
      const config = this.platformSpecificConfig
      
      // 第一步组件属性
      this.stepOneProps = {
        platformConfig: config,
        supportReduceType: config.supportReduceType,
        supportPresellType: config.supportPresellType,
        supportSizeTemplate: config.supportSizeTemplate,
        deliveryDelayOptions: config.deliveryDelayOptions || []
      }
      
      // 第二步组件属性
      this.stepTwoProps = {
        platformConfig: config,
        supportGroupBuy: config.supportGroupBuy,
        supportCoupon: config.supportCoupon,
        supportPromise: config.supportPromise
      }
    },
    
    /**
     * 打开弹窗
     * @param {Object} params - 参数对象
     * @param {Array} params.rowsData - 选中的行数据
     */
    method_open({ rowsData }) {
      this.dialogVisible = true
      this.selectRowsData = rowsData
      this.currentStep = 1
      this.nextLoading = false
      this.$set(this,'detailDataProgress',{ // 初始化进度加载数据
        curNum:0,
        total:0
      });
      this.getConf()
      const { selectedShopList } = this.getIds();
      this.selectedShopList = selectedShopList;
      // 确保组件已加载
      if (!this.stepOneComponent) {
        this.loadPlatformComponents(this.platform)
      }
    },

    async getConf() {
      // 这里是我进行优化的地方，把配置接口在这里调用，原来是在stepOne.vue调用的，这次先改fxg的，后续需要可以再改其他平台的
      const needConfigPlatforms = ['fxg']
      if(!needConfigPlatforms.includes(this.platform)) return 
      const res = await getDistributionConfig({ shopType: this.PLATFORMID });
      this.configData = res || {}
    },
    changeFxgSizeAi(sizeAi) {
      this.configData.sizeAi = sizeAi
    },
    /**
     * 处理下一步操作
     */
    async handleNext() {
      if (!this.$refs.StepOneRef) {
        this.$message.error('组件未准备就绪，请稍后重试')
        return
      }
      
      try {
        let { baseItemIds } = this.getIds();
        let isLoadingFinish = this.detailDataProgress.curNum === baseItemIds.length
        this.$set(this.detailDataProgress,'total',baseItemIds.length); // 设置商品总数
        // 针对拼多多平台进行必填校验
        if (this.platform === 'pdd') {
          const validationResult = await this.validatePddRequiredFields()
          if (!validationResult.isValid) {
            this.$message.error(validationResult.message)
            return
          }
        }
        
        // 获取第一步表单数据
        let params = await this.$refs.StepOneRef.method_getFormData();
        if(!isLoadingFinish){ // 第二步商品数据未加载完成展示进度弹窗
          this.nextLoading = true
        }
        this.stepOneData = {...params}; // 将步骤一的数据存一下，淘宝平台在后面会用上
        delete params.batchFission // 这个字段不需要传给后端
        if(this.platform === 'tb'){
          params = {
            baseItemIds:params.baseItemIds
          }
        }
        this.preSaleTime = params.preSaleTime
        this.flowNumber = params.flowNumber
        // 调用平台特定的保存API
        const apiUrl = this.getPlatformApiUrl('saveBatchTempConf')
        let res
        if(apiUrl){
          res = await this.callPlatformApi(apiUrl, params)
        }else{
          res = {result:1}
        }
        if (res.result === 1) {
          this.currentStep = 2
          // 加载第二步数据
          if(this.detailDataProgress.curNum === 0){// 没有数据时可以加载数据
            this.$refs.StepTwoRef.initData()
          }
        }
      } catch (error) {
        console.error('保存配置失败:', error)
        this.$message.error('保存配置失败，请重试')
      } finally {
        // this.nextLoading = false
      }
    },
    // 返回上一步
    handlePrev(){
      this.currentStep = 1
      this.nextLoading = false
    },
    
    /**
     * 处理铺货操作
     */
    async handleDistribution(extraParams={},cb) {
      if (!this.$refs.StepTwoRef) {
        this.$message.error('组件未准备就绪，请稍后重试')
        return
      }
      const { isPreView,...reset } = extraParams
      const completedList = (this.$refs.StepTwoRef.completedList || []).slice();
      if(completedList.length === 0){
        return this.$message.error('当前没有可铺货的商品!');
      }
      if(this.platform === 'xhs'){
        const { isValid, message } = this.validateXhsTitleBeforePublish()
        if(!isValid){
          this.$message.error(message)
          return
        }
      }
      if(completedList.length === 0){
        return this.$message.error('当前没有可铺货的商品!');
      }
      if(this.platform === 'tb'){
         let batchFissionConfig = [];
         let { publishShopConfigs } = this.stepOneData;
         let baseItemIds = completedList.map(item => item.baseItemId);
         // 组装爆款裂变所需要数据
          completedList.forEach(item => {
            let tbConfig = (item.batchFissionConfig || []).filter(item => item.fissionRuleId)
            tbConfig = tbConfig.map(cfg => {
              return {
                fissionRuleId:cfg.fissionRuleId,
                fissionNumber:cfg.fissionNumber,
                itemId:cfg.itemId,
                shopId:cfg.id || cfg.shopId
              }
            });
            batchFissionConfig = batchFissionConfig.concat(tbConfig)
          });
         let params = {
          itemIds:baseItemIds,
          isNoProgress:!!isPreView,
          itemIds:baseItemIds,
          ...reset,
         }
         if(publishShopConfigs){
           params.publishShopConfigs = publishShopConfigs
         }
         if(batchFissionConfig.length > 0){
            params.batchPublishParams = batchFissionConfig
            if(isPreView){
              params.fissionGoodsExecuteType = 1 //此参数仅针对存在裂变任务的情况下传, 裂变任务结束后需要自动触发铺货任务
            }else{
              params.fissionGoodsExecuteType = 2 //此参数仅针对存在裂变任务的情况下传, 裂变任务结束后自动加入到铺货任务中
            }
         }else{
          params.isNoProgress = false
         }
         this.$emit('shelves', params,cb);
         return;
      }
      // 检查品牌必填校验
      const brandValidationResult = this.validateRequiredBrands()
      if (!brandValidationResult.isValid) {
        this.$message.error(brandValidationResult.message)
        return
      }

      // fxg平台统一校验（标题+尺码）
      if (this.platform === 'fxg' && this.$refs.StepTwoRef.validateBeforePublish) {
        if (!this.$refs.StepTwoRef.validateBeforePublish(this)) {
          return;
        }
      }
     
      // 无异常则直接铺货
      await this.publishWithList(extraParams, cb);
    },

    validateXhsTitleBeforePublish(){
      const ref = this.$refs.StepTwoRef
      const list = ref.completedList || []
      const invalid = list.filter(item => {
        const len = ref.getBytesCount ? ref.getBytesCount(item.name || '') : 0
        return len < 16 || len > 60
      })
      if(invalid.length){
        return { isValid: false, message: `存在${invalid.length}条标题长度不合规（需8-30字或16-60字符）` }
      }
      return { isValid: true, message: '' }
    },

    // 异常确认弹窗 - 继续铺货
    async onContinueDistribution() {
      try {
        this.confirmDialogVisible = false;
        await this.publishWithList();
      } catch (e) {
        console.error(e);
      }
    },

    async publishWithList(extraParams={},cb) {
      const { isPreView,list,...reset } = extraParams
      try {
        this.distributionLoading = false; // 防止误触发，先复位
        this.distributionLoading = true;
        const { shopIds } = this.getIds();
        let batchItemDetailList = this.formatData(list || this.$refs.StepTwoRef.completedList,this.platform)

        const userInfo = this.$store.getters.userInfo
        const params = {
          shopIds,
          flowNumber: this.flowNumber,
          companyId: userInfo.companyId,
          isDistribution:+this.isDistributor,
          ...reset,
        }
        let batchFissionConfig = []
        batchItemDetailList.forEach(item => {
          let _list = (item.batchFissionConfig || []).filter(v => v.fissionRuleId).map(cfg => ({
                fissionRuleId:cfg.fissionRuleId,
                fissionNumber:cfg.fissionNumber,
                itemId:cfg.itemId,
                shopId:cfg.id || cfg.shopId
          }))
          batchFissionConfig = batchFissionConfig.concat(_list);
          delete item.batchFissionConfig
        });
        if(batchFissionConfig.length){
          params.batchPublishParams = batchFissionConfig // 商品裂变规则
          if(isPreView){
            params.fissionGoodsExecuteType = 1 //此参数仅针对存在裂变任务的情况下传, 裂变任务结束后需要字段触发铺货任务
          }else{
            params.fissionGoodsExecuteType = 2 //此参数仅针对存在裂变任务的情况下传, 裂变任务结束后自动加入到铺货任务中
          }
        }
        if(params.fissionGoodsExecuteType != 1){
          // 平台电子面单校验
          let baseItemIds = batchItemDetailList.map(item => item.baseItemId)
          const checkKdResult = await this.$refs.checkKdRef.open(this.platform, baseItemIds);
          if (checkKdResult === 'CANCEL') {
            return 'CANCEL';
          }
          if (checkKdResult && Array.isArray(checkKdResult)) {
            batchItemDetailList = batchItemDetailList.filter(row => checkKdResult.includes(row.baseItemId));
          }
        }
        if(this.platform === 'jd'){
          params.batchJdItemDetails = batchItemDetailList
        }else{
          params.batchItemDetailList = batchItemDetailList
        }
        if(!batchItemDetailList.length){
          return this.$message.error('当前没有可铺货的商品')
        }
        if(!publishLimit(batchItemDetailList.length)){
          return;
        }
        // 调用平台特定的铺货API
        const apiUrl = this.getPlatformApiUrl('batchPublishItem')
        const res = await this.callPlatformApi(apiUrl, params)
        if(res.result == 1 && params.fissionGoodsExecuteType === 1){ // 不需要进度条
          cb && cb();
          return
        }
        let publishType = 'PUBLISH_ITEM';
        if(params.fissionGoodsExecuteType == 2){ // 存在裂变任务的铺货
          publishType = 'GOODS_FISSION'
        }
        if (res.data) {
          this.setCurrentPage(`${this.routerPrefix}goods`)
          this.handleClose()
          await this.publishSpeed({ 
            publishType, 
            resultVisible: true, 
            batchTaskId: res.data 
          })
        } else {
          this.$message.warning('商品铺货失败')
          this.dialogVisible = false
        }
      } catch (error) {
        console.error('铺货失败:', error)
        this.$message.error('铺货失败，请重试')
      } finally {
        this.distributionLoading = false
      }
    },

    // 继续保留以下原有方法，确保组件功能完整
    async callPlatformApi(apiUrl, params) {
      try {
        let platform = this.platform;
        if(this.platform === 'wxsph'){
          platform = 'wxh'
        }
        // 动态导入平台特定的API模块
        const apiModule = await import(`@/servers/prod/center/${platform}.js`)
        
        // 从URL中提取基础方法名
        const baseMethod = apiUrl.split('/').pop()
        // 构建平台特定的方法名（添加平台后缀）
        const platformMethod = `${baseMethod}${platform.charAt(0).toUpperCase() + platform.slice(1)}`
        
        // 检查方法是否存在
        if (apiModule[platformMethod]) {
          return await apiModule[platformMethod](params)
        } else {
          if (apiModule[baseMethod]) {
            return await apiModule[baseMethod](params)
          } else {
            throw new Error(`API方法 ${platformMethod} 和 ${baseMethod} 都不存在`)
          }
        }
      } catch (error) {
        console.error('调用平台API失败:', error)
        throw error
      }
    },

    async validatePddRequiredFields() {
      try {
        if (!this.$refs.StepOneRef) {
          return { isValid: false, message: '表单组件未准备就绪' }
        }
        const isFormValid = await new Promise((resolve) => {
          this.$refs.StepOneRef.$refs.form.validate((valid) => { resolve(valid) })
        })
        if (!isFormValid) {
          return { isValid: false, message: '请完善必填信息后再进行下一步' }
        }
        return { isValid: true, message: '' }
      } catch (error) {
        console.error('拼多多必填校验失败:', error)
        return { isValid: false, message: '表单校验失败，请重试' }
      }
    },

    validateRequiredBrands() {
      try {
        const completedList = this.$refs.StepTwoRef.completedList || []
        const shopIds = this.getIds().shopIds || []
        const invalidItems = []
        completedList.forEach((item, index) => {
          const brandConf = item.shopBrandConf || []
          const hasRequiredEmptyBrand = brandConf.some(config => 
            shopIds.includes(config.shopId) && 
            config.isRequired === true && 
            !config.vvalue
          )
          if (hasRequiredEmptyBrand) {
            invalidItems.push({ index: index + 1, title: item.title || item.itemTitle || '未知商品' })
          }
        })
        if (invalidItems.length > 0) {
          const itemTitles = invalidItems.slice(0, 3).map(item => `第${item.index}行：${item.title}`).join('；')
          const moreText = invalidItems.length > 3 ? `等${invalidItems.length}个商品` : ''
          return { isValid: false, message: `${itemTitles}${moreText}存在必填品牌未填写，请完善后再提交` }
        }
        return { isValid: true, message: '' }
      } catch (error) {
        console.error('品牌校验失败:', error)
        return { isValid: false, message: '品牌校验失败，请重试' }
      }
    },

    /**
     * 格式化数据
     * @param {Array} res - 原始数据
     */
    formatData(res,platform) {
      let list = res.map(item => {
        let obj = {
          ...item,
          shopBrandConf: item.shopBrandConf ? JSON.stringify(item.shopBrandConf || []) : null
        }
        // 爆款裂变数据处理
        let batchFissionConfig = []
        batchFissionConfig = (obj.batchFissionConfig || []).filter(item => item.fissionRuleId).map(item => {
          return {
            fissionRuleId:item.fissionRuleId,
            fissionNumber:item.fissionNumber,
            itemId:item.itemId,
            shopId:item.shopId || item.id
          }
        });
        if(platform === 'jd'){
          obj = {
            baseItemId:obj.baseItemId,
            name:obj.itemName,
            totalStockNum:obj.totalStock,
            skuStocks:obj.skuStockDetails.map(s => ({skuId:s.skuId,stockNum:s.skuStock})),
            shopBrandConf:obj.shopBrandConf,
          }
        }else if(platform === 'pdd'){
            if(obj.skuDetailList){
              obj.skuDetailList = obj.skuDetailList.map(sku => {
                const { skuSpecifications,...reset } = sku;
                return {...reset}
              });
            }
        }
        if(batchFissionConfig.length){
          obj.batchFissionConfig = batchFissionConfig
        }
        return obj
      });
      return list;
    },

    getStepOneData() {
      return this.$refs.StepOneRef?.getFormData?.() || {}
    },
    async batchPublish(data,extraParams={}){
        const { 
          isNotNeedProgress, // 是否不需要铺货进度条
          successCb, // 铺货成功后回调
        } = extraParams;
        try{
          const userInfo = this.$store.getters.userInfo
          let shopList = this.get_AllShops_BySource(this.platform);
          const { shopIds } = this.getIds();
          const normalizedShopIds = Array.isArray(shopIds)
            ? shopIds
                .map(id => (typeof id === 'string' ? Number(id) : id))
                .filter(id => typeof id === 'number' && !Number.isNaN(id))
            : [];
          shopList = shopList && shopList.length && shopList.filter(item => normalizedShopIds.includes(item.id)).map(item=>item.id);
          let params = {
            shopIds: shopList,
            flowNumber: this.flowNumber,
            companyId: userInfo.companyId,
            isDistribution:+this.isDistributor,
          }
          params = merge(params,data)
          // 调用平台特定的铺货API
          const apiUrl = this.getPlatformApiUrl('batchPublishItem');
          const res = await this.callPlatformApi(apiUrl, params);
          let publishType = 'PUBLISH_ITEM';
          if(params.fissionGoodsExecuteType == 2){ // 存在裂变任务的铺货
            publishType = 'GOODS_FISSION'
          }
          if (res.result == 1) {
            successCb && successCb()
            if(isNotNeedProgress){
              return
            }
          }
          if (res.data) {
            this.setCurrentPage(`${this.routerPrefix}goods`)
            this.handleClose()
            await this.publishSpeed({ 
              publishType, 
              resultVisible: true, 
              batchTaskId: res.data 
            })
          } else {
            this.$message.warning('商品铺货失败')
            this.dialogVisible = false
          }
        }catch(error){
          console.error('铺货失败:', error)
          this.$message.error('铺货失败，请重试')
        }
    },
    // 跳过加载直接铺货
    handleSkipLoadPublish(){
      this.handleSkipPublish()
      this.$refs.StepTwoRef.isCanLoadList = false
    },
    // 跳过商品信息确认，直接铺货
    async handleSkipPublish(){
        let { rowsData } = this.getIds()
        let stepOneData = {}
        if(this.$refs.StepOneRef){
          stepOneData = await this.$refs.StepOneRef.method_getFormData();
        }else{
          stepOneData = this.stepOneData
        }
        let flowNumber = stepOneData.flowNumber
        let params = {flowNumber}
        let canPublishPlatList = (rowsData || []).filter(row => row.canPublishPlatform.includes(this.platform));
        if(!canPublishPlatList.length){
          this.$message.error('当前没有已完善资料的商品可以铺货')
          return
        }
        let list = (rowsData || []).map(row => {
          let baseItemId = row.baseItemId
          if (this.isDistributor) {
            baseItemId = row.distributionBaseItemIds?.length ? row.distributionBaseItemIds[0] : row.baseItemId;
          } else {
            baseItemId = row.itemId ? row.itemId : row.baseItemId;
          }
          return {
            baseItemId,
            companyId:row.companyId
          }
        }) 
        if(this.platform === 'jd'){
          params.batchJdItemDetails = list
        }else{
          params.batchItemDetailList = list
        }
        if(this.platform === 'tb'){
          let p = {};
          if(stepOneData.publishShopConfigs){
            p.publishShopConfigs = stepOneData.publishShopConfigs
          }
          this.$emit('shelves', p);
        }else{
          this.batchPublish(params)
        }
        this.handleClose()
    },
    // 加载详情进度
    getDetailProgress(data={}){
        const { curNum,total } = data
        this.detailDataProgress = {
          curNum,
          total,
        }
        if(curNum === total){
          this.nextLoading = false
        }
    },
    // 加载中关闭程序
    handleNextLoad(){
      this.handleClose()
      this.$refs.StepTwoRef.isCanLoadList = false
    },
    handleClose() {
      this.dialogVisible = false
      this.currentStep = 1
      this.flowNumber = ''
      this.selectRowsData = []
      this.$emit('dialog-close');
    },
    preViewFission(){
      this.handleDistribution({
        isPreView:true,
      },() => {
        this.handleClose()
        // 跳转任务中心页面
        this.goPage('task_center')
      })
    },
    // 页面跳转
    goPage(name,params){
        this.$store.dispatch("setIsKeepAlive", false); // 跳转目标页面不使用缓存页面，重新加载
        this.$router.push({
          name: `${this.routerPrefix}${name}`,
        });
    },
  },
  created() { 
    this.getGoodsFissionRules()
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-start;
}

.demo-drawer__footer {
  margin-bottom: 20px;
  margin-top: 10px;
  position: fixed;
  bottom: 0;
  margin-left: 16px;
}

.loadingBox{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .loadingCon{
    text-align: center;
  }
}


::v-deep .el-drawer__header {
  padding: 20px;
  margin-bottom: 0px;
  font-size: 18px;
  font-weight: 700;
  color: #3e4144;
}

::v-deep .el-drawer__body {
  height: 100%;
  padding-bottom: 140px;
  flex: 1;
}
</style>
